<template>
  <div class="qa-detail" :style="{ paddingLeft: '24px' }">
    <router-link :to="'/resource/help/qa/list-' + this.arcitleData['categoryId']"
      ><a-icon type="left" />返回</router-link
    >
    <!-- <div class="guide-content"> -->
    <div class="news_title">
      {{
        this.arcitleData && this.arcitleData["abstracts"]
          ? this.arcitleData["abstracts"]
          : ""
      }}
    </div>
    <div
      class="content"
      v-html="
        this.arcitleData && this.arcitleData['html'] ? this.arcitleData['html'] : ''
      "
    ></div>
    <!-- </div> -->
  </div>
</template>

<script>
import { mixinResourceHelp } from "./mixins/resource-help";
export default {
  mixins: [mixinResourceHelp],
  name: "QaDetail",
  data() {
    return {
      did: null,
      arcitleData: {},
      selectedKeys: [],
      openKeys: [],
    };
  },
  mounted() {
    // this.did = this.$route.params.did;
    // this.getArcitleData({
    //     id: this.$route.params.did;,
    //   });
    this.dataInit();
  },
  methods: {
    async dataInit() {
      this.loading = false;
      if (this.$route.params.did) {
        await this.getArcitleData({ id: this.$route.params.did });
        let selectedKeys =
          this.arcitleData && this.arcitleData["categoryId"]
            ? [this.arcitleData["categoryId"]]
            : [];
        let openKeys =
          this.arcitleData && this.arcitleData["titleId"]
            ? this.arcitleData["titleId"]
            : "";
        console.log({ openKeys, selectedKeys }, "{ openKeys, selectedKeys }");
        this.$emit("dealOpenChange", { openKeys, selectedKeys });
      }
    },
  },

  watch: {
    $route(newRoute) {
      this.dataInit();
      // this.getArcitleData({
      //   id: newRoute.params.did,
      // });
    },
  },
};
</script>

<style lang="sass" scoped>
.qa-detail{

  min-height: 800px;

  // padding-left: 24px;
  .content{
    width: 100%;
    word-break: break-all;
    word-wrap: break-word;
    // display: flex;
    // flex-wrap:wrap;
    padding-top:20px;
    font-size: 18px;
    font-family: 'Alibaba-PuHuiTi-R' !important;
    color: #333646;
    line-height: 30px;
    p{
      padding-bottom:10px;
      // font-family: 'Alibaba-PuHuiTi-R' !important;
    }
    img{
      max-width:100%;

    }

    ::v-deep {
      * {
        font-family: 'Alibaba-PuHuiTi-R' !important;
        // font-size: 18px;
      }
    }

  }
  .news_title{
    font-size:40px;
    color:#333;
    text-align: center;
  }
}
</style>
